import { isPlainObject } from './mcp-tool-json-schema'
import type { McpToolSchema } from './mcp-tool-schema'

export const MCP_APP_FIELDS = [
  'app_provider',
  'org_app_uuid',
  'app_name',
  'tool_name',
  'tool_schema',
] as const

export const MCP_CODE_FIELDS = [
  'code_name',
  'code_description',
  'code_body',
  'code_function_schema',
] as const

interface McpSourceConfig {
  source?: 'app' | 'custom_code'
  tool_schema?: unknown
  code_function_schema?: unknown
}

export const normalizeCodeName = (name: string) => name.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase()

const allowsNull = (prop: unknown): boolean =>
  isPlainObject(prop) &&
  (prop.type === 'null' ||
    (Array.isArray(prop.type) && prop.type.includes('null')) ||
    (Array.isArray(prop.anyOf) && prop.anyOf.some(allowsNull)))

// Generated function schemas are strict mode: an optional parameter is required but nullable,
// and agent-runner sends an empty one to main() as None.
const withNullablesOptional = (parameters: McpToolSchema): McpToolSchema => {
  const properties = isPlainObject(parameters.properties) ? parameters.properties : {}
  return Array.isArray(parameters.required)
    ? {
        ...parameters,
        required: parameters.required.filter((name) => !allowsNull(properties[name])),
      }
    : parameters
}

export const getMcpInputSchema = (config: McpSourceConfig): McpToolSchema | null => {
  if (config.source === 'custom_code') {
    const parameters =
      isPlainObject(config.code_function_schema) && config.code_function_schema.parameters
    return isPlainObject(parameters) ? withNullablesOptional(parameters) : null
  }
  return isPlainObject(config.tool_schema) ? config.tool_schema : null
}

export const mcpSourceConfig = <T extends Record<string, unknown>>(config: T): T => {
  const source = config.source ?? 'app'
  const result = { ...config, source }
  for (const key of source === 'custom_code' ? MCP_APP_FIELDS : MCP_CODE_FIELDS) {
    delete result[key]
  }
  return result
}
